import { adminHttpClient } from '../../../commons/adminHttpClient'
import PagedList from '../../../commons/pagedList'

export type RejectPerksExpenseApproval = {
  expenseId: string
}

const rejectExpenseApprovals = (body: RejectPerksExpenseApproval): Promise<PagedList<RejectPerksExpenseApproval>> => {
  return adminHttpClient.post('/AdminDashboard/Perks/Reimbursements/RejectExpense/', body)
}

export default rejectExpenseApprovals
